import type { TrackingContext } from '@mentimeter/http-clients';
import { ViewOnlyAuthButtons } from 'features/core/editor/Header/view-only/ViewOnlyAuthButtons';
import { ViewOnlyCommentDrawer } from './ViewOnlyCommentDrawer';

export const ViewOnlyFooter = ({
  isVisitor,
  buttonSize,
  seriesId,
  trackingContext,
  isCommentDrawerOpen,
  isShared,
  currentPlan,
  roleInWorkspace,
}: {
  isVisitor: boolean;
  buttonSize: 'default' | 'compact';
  seriesId: string;
  trackingContext: TrackingContext;
  isCommentDrawerOpen: boolean;
  isShared: boolean;
  currentPlan: string;
  roleInWorkspace: string;
}) => {
  if (isVisitor)
    return (
      <ViewOnlyAuthButtons
        buttonSize={buttonSize}
        seriesId={seriesId}
        trackingContext={trackingContext}
      />
    );

  return (
    <ViewOnlyCommentDrawer
      open={isCommentDrawerOpen}
      isShared={isShared}
      currentPlan={currentPlan}
      roleInWorkspace={roleInWorkspace}
      trackingContext={trackingContext}
    />
  );
};
